import { useApi } from "#hooks/useApi"
import { STATUS_COURSE, TARJETA_COLOR } from "#training/constants"
import { statisticsGet } from "#training/services/Api"
import { Box, Paper, Skeleton } from "@mui/material"
import { useMemo } from "react"
import {
	VictoryAxis,
	VictoryBar,
	VictoryChart,
	VictoryLabel,
	VictoryTheme,
} from "victory"

const StatisticsGraph = ({ autoFetch, params }) => {
	const paramsGraph = useMemo(() => {
		return {
			...params,
			resume: true,
		}
	}, [params])
	const { data, loading } = useApi(statisticsGet, {
		autoFetch,
		params: paramsGraph,
	})
	if (loading) return <Skeleton variant="rectangular" height={"20vh"} />
	return (
		<Box
			component={Paper}
			padding={8}
			width="100%"
			margin={4}
			display="flex"
			justifyContent="center"
			alignItems="center"
			gap={10}
		>
			<GraphStatus data={data} />
			<GraphSucursales data={data} />
		</Box>
	)
}
export default StatisticsGraph

const GraphStatus = ({ data }) => {
	const dataGraph = []
	const title = { por_aprobar: "POR APROBAR" }
	for (const key in data) {
		if (Object.prototype.hasOwnProperty.call(data, key)) {
			if (["total", "sucursales"].includes(key)) continue
			const element = data[key]
			const porcentaje = element
			const name_field = `${key}`.toUpperCase()
			dataGraph.push({
				x: title[key] || `${name_field}S`,
				name: name_field,
				y: porcentaje,
				count: element,
			})
		}
	}

	return (
		<Box>
			<VictoryChart
				padding={{ top: 20, bottom: 50, left: 75, right: 0 }}
				domainPadding={{ x: [40, 11] }}
				theme={VictoryTheme.clean}
			>
				<VictoryAxis
					label={`Cursos ${data?.total}`}
					dependentAxis
					style={{
						axisLabel: { padding: 60 },
					}}
					tickFormat={(tick) => {
						return tick.toFixed(0) > 1 ? tick.toFixed(0) : ""
					}}
				/>

				<VictoryAxis tickLabelComponent={<VictoryLabel angle={-15} textAnchor="end" />} />
				<VictoryBar
					data={dataGraph}
					style={{
						data: {
							fill: ({ datum }) => {
								if (Object.keys(STATUS_COURSE).includes(`${datum["name"]}`))
									return TARJETA_COLOR[STATUS_COURSE[datum["name"]]]
							},
							stroke: ({ index }) => (+index % 2 === 0 ? "#000000" : "#c43a31"),
							fillOpacity: 0.7,
							strokeWidth: 0,
						},
						labels: {
							fontSize: 10,
						},
					}}
				/>
			</VictoryChart>
		</Box>
	)
}
const GraphSucursales = ({ data }) => {
	const { sucursales } = data
	const dataGraph = []

	for (const key in sucursales) {
		const element = sucursales[key]
		const porcentaje = element?.porcentaje || 0
		dataGraph.push({
			x: `${key}`.toUpperCase(),
			y: porcentaje,
			count: element,
		})
	}
	const truncate = (text, maxLength = 10) =>
		text?.length > maxLength ? text.slice(0, maxLength) + "…" : text

	return (
		<Box padding={8}>
			<VictoryChart
				padding={{ top: 20, bottom: 75, left: 85, right: 0 }}
				domainPadding={{ x: [40, 11] }}
				theme={VictoryTheme.clean}
			>
				<VictoryAxis
					label={"Porcentajes de Cursos"}
					dependentAxis
					style={{
						axisLabel: { padding: 60 },
					}}
					tickFormat={(tick) => {
						return tick.toFixed(0) > 1 ? `${tick.toFixed(0)}%` : ""
					}}
				/>
				<VictoryAxis
					tickLabelComponent={
						<VictoryLabel
							labels={({ datum }) => truncate(`${datum?.x}`, 5)}
							text={({ datum }) => truncate(dataGraph[datum - 1]?.x, 12)}
							angle={-25}
							textAnchor="end"
						/>
					}
				/>
				<VictoryBar
					data={dataGraph}
					labels={({ datum }) => `${datum?.y}`.toUpperCase()}
					barRatio={dataGraph.length === 1 ? 4.5 : 0.5}
					style={{
						data: {
							fill: ({ datum }) => {
								if (Object.keys(STATUS_COURSE).includes(`${datum["name"]}`))
									return TARJETA_COLOR[STATUS_COURSE[datum["name"]]]
							},
							stroke: ({ index }) => (+index % 2 === 0 ? "#000000" : "#c43a31"),
							fillOpacity: 0.7,
							strokeWidth: 0,
						},
						labels: {
							fontSize: 10,
						},
					}}
				/>
			</VictoryChart>
		</Box>
	)
}
